@if (rowData.commonAlarm) {
  <div class="icon-wrapper">
    <geaui-icon-v3 class="filter-icon" [file]="'16px_warning-sign'" color="black" />
  </div>
}
